import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopNavBar from "../../components/TopNavBar";
import Footer from "../../components/Footer";
import "./index.css";

const MainLayout: React.FC = () => {
  const location = useLocation();
  const isReadytoFeastAvailable = location.pathname === "/" || location.pathname === "/order";

  const isReadytoFeastAvailablePart2 = location.pathname === "/documents"

  const isReadytoFeastAvailablePart3 = location.pathname === "/about-us";

  return (
    <>
      <TopNavBar />
      <div
        className={
          isReadytoFeastAvailable
            ? "outlet-container"
            : isReadytoFeastAvailablePart2
              ? "outlet-container2" : isReadytoFeastAvailablePart3 ? "outlet-container3"
                : ""
        }
      >
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;

